import { Routes, Route } from 'react-router-dom';
import useLocalStorage from 'use-local-storage';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import Home from './pages/Home';
import AllPosts from './pages/AllPosts';
import SinglePost from './pages/SinglePost';
import AllTags from './pages/AllTags';
import SingleTag from './pages/SingleTag';
import NotFound from './pages/404';

export default function App() {
  const [isDark, setIsDark] = useLocalStorage("isDark", false);

  return (
    <div className="App" data-theme={isDark ? "dark" : "light"}>
      <Navbar/>
      <Routes>
        <Route path='/' element={<Home/>} />
        <Route path='/posts' element={<AllPosts/>} />
        <Route path='/posts/:slug' element={<SinglePost/>} />
        <Route path='/tags' element={<AllTags/>} />
        <Route path='/tags/:slug' element={<SingleTag/>} />
        <Route path='*' element={<NotFound/>} />
      </Routes>
      <Footer isDark={isDark} handleChange={() => setIsDark(!isDark)}/>
    </div>
  );
}
